import axios from "axios";
import * as Sentry from "@sentry/react";

const request = axios.create({
  baseURL: process.env.REACT_APP_CD_API_URL
});

const setHeaders = token => ({
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  }
});

export const getPowerBiCompanyRef = async accessToken =>
  request
    .get("/companyName", setHeaders(accessToken))
    .then(({ data }) => data.powerBiCompanyRef);

export const getCompanyAndContactRef = async accessToken =>
  request
    .get("/companyAndContact", setHeaders(accessToken))
    .then(({ data }) => ({
      companyRef: data.powerBiCompanyRef,
      contactRef: data.contactRef ? parseInt(data.contactRef, 10) : null
    }));

export const getPowerBiEmbedToken = async (
  accessToken,
  reportId = process.env.REACT_APP_REPORT_ID
) =>
  request
    .get(`/issueEmbedToken?reportId=${reportId}`, setHeaders(accessToken))
    .then(({ data }) => data.embedToken);

export const getAccountPermission = async accessToken =>
  request
    .get("/accountPermission", setHeaders(accessToken))
    .then(({ data }) => data)
    .catch(e => {
      Sentry.captureException(e);
    });

export const getCostCentres = async accessToken =>
  request
    .get("/costCenters", setHeaders(accessToken))
    .then(({ data }) => data)
    .catch(e => {
      Sentry.captureException(e);
    });
